module.exports = __webpack_public_path__ + "media/images/common/logo/logo-w-8d8edc462664e2cb5899aec7c0cda5ef.svg";